import { Text, TextType } from 'ui-components/components/text';

import PickupInformationByFulfillmentPlanId from '../../../../fulfillment-planner/local-delivery/pickup-information/by-fulfillment-plan-id';
import { OrdersSidebarSection } from '../orders-sidebar-section';
import messages from './messages';
import { useOrdersSidebarPickupInformationSection } from './use-orders-sidebar-pickup-information-section';
import sectionStyle from '../orders-sidebar-section.module.less';

/**
 * @param {object} props
 * @param {object} props.dragHandleProps
 * @returns {React.JSX.Element}
 */
export const PickupInformationSection = ({ dragHandleProps }) => {
  const { isLocalDelivery, open, toggleCollapsableSection } = useOrdersSidebarPickupInformationSection();

  if (!isLocalDelivery) {
    return null;
  }

  const headerContent = <Text textType={TextType.H4} value={messages.pickupInformation} />;

  const sectionContent = <PickupInformationByFulfillmentPlanId className={sectionStyle['order-sidebar-section-default-padding']} />;

  return (
    <OrdersSidebarSection
      dragHandleProps={dragHandleProps}
      headerContent={headerContent}
      isExpanded={open}
      sectionContent={sectionContent}
      toggleIsExpanded={toggleCollapsableSection}
    />
  );
};
